import {
    Component,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { JobType } from '@intranet/modules/jobs';
import { UserGroup } from '@intranet/modules/users';

@Component({
    selector: 'admin-jobtype-table',
    templateUrl: './jobtype-table.component.html',
    styleUrls: ['./jobtype-table.component.scss'],
})
export class AdminJobTypeTableComponent {
    @Output() selected = new EventEmitter<JobType>();

    private _jobTypes: JobType[] = [];

    @Input() set jobtypes(value: JobType[]) {
        this._jobTypes = Array.isArray(value) ? [...value] : [];
        this.sortGroups();
    }

    get jobtypes(): JobType[] {
        return this._jobTypes;
    }

    sortBy: string = 'description';
    sortDir: 'asc' | 'desc' = 'asc';

    onSort(column: string) {
        if (this.sortBy === column) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = column;
            this.sortDir = 'asc';
        }

        this.sortGroups();
    }

    sortGroups() {
        this._jobTypes = [...this._jobTypes].sort((a, b) => {
            let valueA: any;
            let valueB: any;

            if (this.sortBy === 'description') {
                valueA = a.description.toLowerCase();
                valueB = b.description.toLowerCase();
            } else if (this.sortBy === 'jobCount') {
                valueA = a.count;
                valueB = b.count;
            }

            return this.sortDir === 'asc' ? (valueA > valueB ? 1 : -1) : (valueA < valueB ? 1 : -1);
        });
    }

    onSelect(jobType: JobType) {
        this.selected.emit(jobType);
    }
}